import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=4c9a4762&scoped=true&"
import script from "./PrivacyDialog.vue?vue&type=script&lang=ts&"
export * from "./PrivacyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyDialog.vue?vue&type=style&index=0&id=4c9a4762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a4762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VDialog,VRow})
